export { default as Content } from './Content.client';
